import styled from 'styled-components/native';
import { Theme } from '../../theme';
import { withDeviceType } from '../../hooks';

interface DeviceTypeProps {
  deviceType: 'mobile' | 'tablet' | 'desktop';
}

export const Container = styled.View`
  display: flex;
  width: 100%;
  height: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
`;

export const InnerContainer = withDeviceType(styled.View`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: ${(props: DeviceTypeProps & { theme: Theme }) => props.deviceType !== 'desktop' ? props.theme.spacing.md : props.theme.spacing.xxl};
`);

export const Illustration = styled.Image`
  width: 240px;
  height: 180px;
  margin-bottom: 14px;
`;

export const Title = styled.Text`
  padding-bottom: ${(props: { theme: Theme }) => props.theme.spacing.sm};
  font-size: ${(props: { theme: Theme }) => props.theme.typography.textSizes.lg};
  font-weight: bold;
  text-align: center;
  color: rgba(0,0,0,0.92);
`;

export const SubTitle = styled.Text`
  font-size: ${(props) => props.theme.typography.textSizes.sm};
  color: ${(props) => props.theme.palette.fadedText};
  text-align: center;
  line-height: ${(props) => Number(props.theme.typography.textSizes.sm.replace('px', '')) * 1.55}px;
  max-width: 360px;
`;
